import React from 'react'
import PropTypes from 'prop-types'
import { Title } from '@offerzen/pinata-shame'
import { MarkdownRenderer } from '@offerzen/pinata-shame/markdowns'

import styles from './styles'

const RoleDescriptionSection = ({ description }) => {
  if (!description) return null

  return (
    <section>
      <Title className={styles.heading}>Role description</Title>
      <MarkdownRenderer className={styles.markdown} source={description} />
    </section>
  )
}

RoleDescriptionSection.propTypes = {
  description: PropTypes.string,
}

export default RoleDescriptionSection
